module.exports = __webpack_public_path__ + "img/test.b19f946b.png";